import { observable } from "mobx";
import { message } from "antd";
import AbstractDeclarantStore from "./AbstractDeclarantStore";
import { Download } from "../components/declarants/Interfaces";
import ee from "../services/EventEmitter";
import {
  DELETE_DECLARANT_EVENT,
  DOWNLOAD_CMR_IN_DECLARANTS_TABLE,
} from "../constants/events";
import getFileNameFromContentDisposition from "../helpers/parsers";
import downloadFile from "../helpers/downloadFile";
import downloadCmrPdf from "../utils/downloadCmrPdf";
import { CmrEventParams, IObjectMap } from "../interfaces/common";
import { EXPORT_TO_EXCEL_TIMEOUT_MESSAGE } from "components/tables/declarantTable/constants";

class DeclarantStore extends AbstractDeclarantStore implements Download {
  constructor() {
    super();
  }

  init() {
    ee.on(DELETE_DECLARANT_EVENT, (id) => {
      this.deleteEntity(id);
    });

    ee.on(DOWNLOAD_CMR_IN_DECLARANTS_TABLE, (value: CmrEventParams) => {
      this.downloadPdf(value.id);
    });
  }

  @observable
  selectedRows: (string | number)[] = [];

  @observable
  isLoadingButton = false;

  downloadXml(): void {
    this.apiManager
      .sendDownloadRequest(this.selectedRows)
      .then((response) => {
        const fileName = getFileNameFromContentDisposition(
          response.headers.get("Content-Disposition")
        );

        response.blob().then((blob) => {
          downloadFile(blob, fileName);
        });
      })
      .catch(async (response) => {
        const data = await response.json();
        message.error(data.message);
      });
  }

  downloadPdf(recordId: number): void {
    downloadCmrPdf(this.apiManager, recordId);
  }

  downloadExcel(params: IObjectMap): void {
    if (this.isLoadingButton) {
      return;
    }

    this.isLoadingButton = true;

    this.apiManager
      .downloadDeclarantAsExcelFile(params)
      .then((response) => {
        const fileName = getFileNameFromContentDisposition(
          response.headers.get("Content-Disposition")
        );

        response.blob().then((blob) => {
          downloadFile(blob, fileName);
        });
      })
      .catch(async (response) => {
        if (Object.keys(response).length == 0) {
          message.error(EXPORT_TO_EXCEL_TIMEOUT_MESSAGE);
          return;
        }
        const data = await response.json();

        message.error(data.message);
      })
      .finally(() => {
        this.isLoadingButton = false;
      });
  }
}

export default DeclarantStore;
